module.exports = __webpack_public_path__ + "static/img/VDscenario1.3155493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/VDscenario1.png
// module id = yxl5
// module chunks = 0